import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "../components/TimeSheetFolder/GatnixAccountHelp.css";
import Header from "./Header";
import Troubleshooting from "./Troubleshooting"; // Import Troubleshooting component
import CreateApprovalManager from "../components/TimeSheetFolder/Childcomponent/CreateApprovalManager";
import UnderstandingBilling from "../components/TimeSheetFolder/Childcomponent/UnderstandingBilling";
import ManageInvoices from "../components/TimeSheetFolder/Childcomponent/ManageInvoices";
import ConsultantData from "../components/TimeSheetFolder/Childcomponent/ConsultantData";
import SATReportGeneration from "../components/TimeSheetFolder/Childcomponent/SATReportGeneration";
import ConsultantProfileEdit from "../components/TimeSheetFolder/Childcomponent/ConsultantProfileEdit";
import SchedulerLogs from "../components/TimeSheetFolder/Childcomponent/SchedulerLogs";
import ViewConsultantDetails from "../components/TimeSheetFolder/Childcomponent/ViewConsultantDetails";
import EmailTemplateGuide from "../components/TimeSheetFolder/EmailTemplateGuide";
import ProfileSetup from "../components/TimeSheetFolder/Childcomponent/ProfileSetup";
import VendorClientManagement from "./VendorClientManagement";
import OrganizationInformation from "./OrganizationInformation";
import ManageSubmissionSheets from "./ManageSubmissionSheets";
import ViewOrganizationDetails from "./ViewOrganizationDetails";
import ViewEmailHistory from "./ViewEmailHistory";
import {
  faBars,
  faTimes,
  faCircleChevronUp,
  faCircleChevronDown,
} from "@fortawesome/free-solid-svg-icons";
import ManageSchedulerSettings from "../components/TimeSheetFolder/ManageSchedulerSettings";
import ViewSchedulerLogs from "./ViewSchedulerLogs";
import ManageSATReports from "./ManageSATReports";
import BillingAndSATReports from "../components/TimeSheetFolder/BillingAndSATReports";
import ManageBillingAndReports from "./ManageBillingAndReports";
import UserAndBillingOverview from "./UserAndBillingOverview";
import ManageConsultantLicenses from "./ManageConsultantLicenses";
import ManageOrders from "./ManageOrders";
import ResumeBuilder from "./ResumeBuilder";
import AIResumeMatcher from "../components/TimeSheetFolder/AIResumeMatcher";
import ImportOrCreateResume from "./ImportOrCreateResume";
import TemplateSettings from "./TemplateSettings";
import SavedJobs from "../components/SavedJobs";
import Footer1 from "./Footer1";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ViewEmployer from "../components/ViewEmployer";
import RestrictEmployers from "../components/RestrictEmployers";
import RestrictConsultants from "../components/RestrictConsultants";
import Timesheetcontnent from "../components/Timesheetcontnent";
import ViewSubmittedSheets from "../components/ViewSubmittedSheets";
import ViewApprovedSheets from "../components/ViewApprovedSheets";
import PendingTimeSheets from "../components/PendingTimeSheets";
import RejectedTimeSheets from "../components/RejectedTimeSheets";
import RecalledTimeSheets from "../components/RecalledTimeSheets";
import AddOrViewEmployee from "../components/TimeSheetFolder/AddViewEmployee";
import AddOrViewClient from "../components/TimeSheetFolder/AddOrViewClient";
import ManageConsultants from "../components/TimeSheetFolder/Superadmin/ManageConsultants";
import SubmissionComments from "../components/TimeSheetFolder/Superadmin/SubmissionComments";
import EmailTemplates from "../components/TimeSheetFolder/Superadmin/EmailTemplates";
import EmailTemplatesGuide from "../components/TimeSheetFolder/Superadmin/EmailTemplatesGuide";
import SchedulerSettings from "../components/TimeSheetFolder/Superadmin/SchedulerSettings";
// import EmailLog from "./Superadmin/EmailLog";
import ResumeAnalyzerGuide from "../components/TimeSheetFolder/Superadmin/ResumeAnalyzerGuide";
import ResumeBuilderGuide from "../components/TimeSheetFolder/Superadmin/ResumeBuilderGuide";
import ResumeMatcherGuide from "../components/TimeSheetFolder/Superadmin/ResumeMatcherGuide";
import SavedResumes from "../components/TimeSheetFolder/Superadmin/SavedResumes";
import SavedJobsAdmin from "../components/TimeSheetFolder/Superadmin/SavedJobsAdmin";
import RestrictionAdminLoginStatus from "../components/TimeSheetFolder/Superadmin/RestrictionAdminLoginStatus";
import RestrictionEmployerLoginStatus from "../components/TimeSheetFolder/Superadmin/RestrictionEmployerLoginStatus";
import RestrictionConsultant from "../components/TimeSheetFolder/Superadmin/RestrictionConsultant";
import RestrictModuleAccess from "../components/TimeSheetFolder/Superadmin/RestrictModuleAccess";
import AdminLoginStatus from "../components/TimeSheetFolder/Superadmin/AdminLoginStatus";
import ConsultantStatusManagement from "../components/TimeSheetFolder/ConsultantStatusManagement";
import AdminAccessManagement from "../components/TimeSheetFolder/AdminAccessManagement";
import GenerateSATReport from "../components/TimeSheetFolder/GenerateSATReport";
import SearchSidebar from "../components/SearchSidebar";
import SATReportGuide from "../components/TimeSheetFolder/Superadmin/SATReportGuide";
import AdminAccessControl from "../components/TimeSheetFolder/Superadmin/AdminAccessControl";
import AdminProfile from "../components/TimeSheetFolder/Superadmin/AdminProfile";
import AssignLicensesToConsultant from "../components/TimeSheetFolder/Superadmin/AssignLicensesToConsultant";
import Create from "../components/TimeSheetFolder/Create";
import ProfileEmployee from "../components/TimeSheetFolder/Childcomponent/ProfileEmployee";
import TimesheetsEmployee from "../components/TimeSheetFolder/Childcomponent/TimesheetsEmployee";
import SubmittedSheetsEmployee from "../components/TimeSheetFolder/Childcomponent/SubmittedSheetsEmployee";
import ApprovedSheetsEmployee from "../components/TimeSheetFolder/Childcomponent/ApprovedSheetsEmployee";
import PendingSheetsEmployee from "../components/TimeSheetFolder/Childcomponent/PendingSheetsEmployee";
import RejectedTimeSheetsEmployee from "../components/TimeSheetFolder/Childcomponent/RejectedTimeSheetsEmployee";
import SuperAdminProfile from "../components/TimeSheetFolder/Superadmin/SuperAdminProfile";
import ApprovalManagerSuperAdmin from "../components/TimeSheetFolder/Superadmin/ApprovalManagerSuperAdmin";
import EmployeeSuperAdmin from "../components/TimeSheetFolder/Superadmin/EmployeeSuperAdmin";
import EmployeeRecalledSheet from "../components/TimeSheetFolder/Childcomponent/EmployeeRecalledSheet";
import ApprovalManagerRecalled from "../components/TimeSheetFolder/Childcomponent/ApprovalManagerRecalled";
import SuperAdminApprovedSheet from "../components/TimeSheetFolder/Superadmin/SuperAdminApprovedSheet";
import SuperAdminPendingSheet from "../components/TimeSheetFolder/Superadmin/SuperAdminPendingSheet";
import SuperAdminRejectedSheet from "../components/TimeSheetFolder/Superadmin/SuperAdminRejectedSheet";
import SuperAdminRecalledSheet from "../components/TimeSheetFolder/Superadmin/SuperAdminRecalledSheet";
import TimeSheetSettings from "../components/TimeSheetFolder/Superadmin/TimeSheetSettings";
import OrganizationSettings from "../components/TimeSheetFolder/Superadmin/OrganizationSettings";
import SuperAdminHelpDesk from "../components/TimeSheetFolder/Superadmin/SuperAdminHelpDesk";
import SuperAdminSubmittedSheet from "../components/TimeSheetFolder/Superadmin/SuperAdminSubmittedSheet";
import SuperAdminProject from "../components/TimeSheetFolder/Superadmin/SuperAdminProject";
import SearchSidebarTime from "./SearchSidebarTime";
import SignInGuide from "./TimeSheetFolder/SigninGuide";
import AddorViewClientDetails from "./TimeSheetFolder/Superadmin/AddorViewClientDetails";


// Individual components for each help topic

const Timesheet = () => {
  const location = useLocation();

  const [openMenus, setOpenMenus] = useState({});
  const [isSidebarVisible, setSidebarVisible] = useState(false); // Handles sidebar visibility
  const [activeMenus, setActiveMenus] = useState({}); // Tracks which submenus are open

  // Toggles sidebar visibility
  const toggleSidebarVisibility = () => {
    setSidebarVisible((prev) => !prev);
  };

  const handleMenuClick = (menu) => {
    setOpenMenus((prev) => ({
      ...prev,
      [menu]: !prev[menu],
    }));
  };

  const isActive = (path) => location.pathname === path;


  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 800) {
        setSidebarVisible(true); 
      } else {
        setSidebarVisible(false); 
      }
    };

    
    handleResize();

    
    window.addEventListener("resize", handleResize);

    
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); 

  
  const handleSubMenuToggle = (menuName) => {
    setActiveMenus((prev) => ({ ...prev, [menuName]: !prev[menuName] }));
  };

  let content = null;
  if (location.pathname === "/time/timesheet/create-approval-manager") {
    content = <CreateApprovalManager />;
  } else if (location.pathname === "/time/timesheet/understanding-billing") {
    content = <UnderstandingBilling />;
  } else if (location.pathname === "/time/timesheet/manage-invoices") {
    content = <ManageInvoices />;
  } else if (location.pathname === "/time/timesheet/consultant-data") {
    content = <ConsultantData />;
  } else if (location.pathname === "/time/timesheet/troubleshooting") {
    content = <Troubleshooting />;
  } else if (location.pathname === "/time/timesheet/satreportgeneration") {
    content = <SATReportGeneration />;
  } else if (location.pathname === "/time/timesheet/consultantprofileedit") {
    content = <ConsultantProfileEdit />;
  } else if (location.pathname === "/time/timesheet/schedulerlogs") {
    content = <SchedulerLogs />;
  } else if (
    location.pathname === "/time/timesheet/viewconsultantdetails" ||
    location.pathname === "/time/admin/viewconsultantdetails" ||
    location.pathname === "/time/superadmin/viewconsultantdetails"
  ) {
    content = <ViewConsultantDetails />;
  } else if (
    location.pathname === "/time/timesheet/viewEmployer" ||
    location.pathname === "/time/admin/viewEmployer" ||
    location.pathname === "/time/superadmin/viewEmployer"
  ) {
    content = <ViewEmployer />;
  } else if (
    location.pathname === "/time/timesheet/restrictEmployers" ||
    location.pathname === "/time/admin/restrictEmployers" ||
    location.pathname === "/time/superadmin/restrictEmployers"
  ) {
    content = <RestrictEmployers />;
  } else if (
    location.pathname === "/time/timesheet/restrictConsultants" ||
    location.pathname === "/time/admin/restrictConsultants" ||
    location.pathname === "/time/superadmin/restrictConsultants"
  ) {
    content = <RestrictConsultants />;
  } else if (
    location.pathname === "/time/timesheet/emailtemplateguide" ||
    location.pathname === "/time/consultant/emailtemplateguide"
  ) {
    content = <EmailTemplateGuide />;
  } else if (location.pathname === "/time/timesheet/profilesetup") {
    content = <ProfileSetup />;
  } else if (location.pathname === "/time/timesheet/vendorclientmanagement") {
    content = <VendorClientManagement />;
  } else if (location.pathname === "/time/timesheet/organizationinformation") {
    content = <OrganizationInformation />;
  } else if (
    location.pathname === "/time/timesheet/managesubmissionsheets" ||
    location.pathname === "/time/consultant/managesubmissionsheets"
  ) {
    content = <ManageSubmissionSheets />;
  } else if (location.pathname === "/time/admin/managesubmissionsheets") {
    content = <ManageSubmissionSheets />;
  } else if (location.pathname === "/time/employee/rejectedtimesheets") {
    content = <RejectedTimeSheets />;
  } else if 
    (location.pathname === "/time/employee/recalledtimesheets" ){
      content = <EmployeeRecalledSheet />
    }
    else if
   ( location.pathname === "/time/approverManagers/recalledtimesheets"){
     content = <ApprovalManagerRecalled />;
   
  } else if (location.pathname === "/time/timesheet/vieworganizationdetails") {
    content = <ViewOrganizationDetails />;
  } else if (location.pathname === "/time/timesheet/manageschedulersettings") {
    content = <ManageSchedulerSettings />;
  } else if (location.pathname === "/time/timesheet/viewemailhistory") {
    content = <ViewEmailHistory />;
  } else if (location.pathname === "/time/timesheet/viewschedulerlogs") {
    content = <ViewSchedulerLogs />;
  } else if (
    location.pathname === "/time/timesheet/managesatreports" ||
    location.pathname === "/time/consultant/managesatreports"
  ) {
    content = <ManageSATReports />;
  } else if (location.pathname === "/time/timesheet/billingandsatreports") {
    content = <BillingAndSATReports />;
  } else if (location.pathname === "/time/timesheet/managebillingandreports") {
    content = <ManageBillingAndReports />;
  } else if (
    location.pathname === "/time/timesheet/userandbillingoverview" ||
    location.pathname === "/time/admin/userandbillingoverview" ||
    location.pathname === "/time/superadmin/userandbillingoverview"
  ) {
    content = <UserAndBillingOverview />;
  } else if (
    location.pathname === "/time/timesheet/manageconsultantlicenses" ||
    location.pathname === "/time/superadmin/manageconsultantlicenses"
  ) {
    content = <ManageConsultantLicenses />;
  } else if (
    location.pathname === "/time/timesheet/manageorders" ||
    location.pathname === "/time/superadmin/manageorders"
  ) {
    content = <ManageOrders />;
  } else if (
    location.pathname === "/time/timesheet/resumebuilder" ||
    location.pathname === "/time/admin/resumebuilder" ||
    location.pathname === "/time/consultant/resumebuilder"
  ) {
    content = <ResumeBuilder />;
  } else if (
    location.pathname === "/time/timesheet/airesumematcher" ||
    location.pathname === "/time/admin/airesumematcher" ||
    location.pathname === "/time/superadmin/superadmin" ||
    location.pathname === "/time/consultant/managesatreports" ||
    location.pathname === "/time/consultant/airesumematcher" ||
    location.pathname === "/time/superadmin/airesumematcher"
  ) {
    content = <AIResumeMatcher />;
  } else if (location.pathname === "/time/timesheet/importorcreateresume") {
    content = <ImportOrCreateResume />;
  } else if (
    location.pathname === "/time/employee/timesheet" ||
    location.pathname === "/time/approverManagers/timesheet"
  ) {
    content = <Timesheetcontnent />;
  }
  else if (
    location.pathname === "/time/approverManagers/project"
  ) {
    content = <Create />;
  }  else if (
   
    location.pathname === "/time/approverManagers/timesubmittedSheets"
  ) {
    content = <ViewSubmittedSheets />;
  } else if (
    
    location.pathname === "/time/approverManagers/approvedsheets"
  ) {
    content = <ViewApprovedSheets />;
  } else if (
   
    location.pathname === "/time/approverManagers/pendingtimesheets"
  ) {
    content = <PendingTimeSheets />;
  } else if (location.pathname === "/time/timesheet/templatesettings") {
    content = <TemplateSettings />;
  } else if (
    location.pathname === "/time/admin/templatesettings" ||
    location.pathname === "/time/superadmin/emailtemplateguide"
  ) {
    content = <TemplateSettings />;
  } else if (
    location.pathname === "/time/timesheet/savedjobs" ||
    location.pathname === "/time/admin/savedjobs"
  ) {
    content = <SavedJobs />;
  } else if (
    location.pathname === "/time/approverManagers/rejectedtimesheets"

  ) {
    content = <RejectedTimeSheets />;
  }
   else if (
    location.pathname === "/time/timesheet/profilesetup" ||
    location.pathname === "/time/consultant/profilesetup" ||

    location.pathname === "/time/approverManagers/profile"
  ) {
    content = <ProfileSetup />;
    
  } else if (location.pathname === "/time/approverManagers/addOrviewemployee") {
    content = <AddOrViewEmployee />;
  } else if (location.pathname === "/time/approverManagers/addOrViewClient") {
    content = <AddOrViewClient />;
  }

  // superadmin routes
  else if (location.pathname === "/time/timesheet/manageConsultantssuperadmin") {
    content = <ManageConsultants />;
  } else if (location.pathname === "/time/timesheet/submissions-sheet") {
    content = <SubmissionComments />;
  } else if (location.pathname === "/time/superadmin/emails") {
    content = <EmailTemplates />;
  } else if (location.pathname === "/time/superadmin/emails") {
    content = <EmailTemplatesGuide />;
  } else if (location.pathname === "/time/superadmin/schedulersettings") {
    content = <SchedulerSettings />;
  } else if (location.pathname === "/time/superadmin/emaillogs") {
    content = <AddorViewClientDetails />;
  } else if (location.pathname === "/time/superadmin/resumeAnalyzerGuide") {
    content = <ResumeAnalyzerGuide />;
  } else if (location.pathname === "/time/superadmin/resumeBuilderGuide") {
    content = <ResumeBuilderGuide />;
  } else if (location.pathname === "/time/superadmin/resumeMatcherGuide") {
    content = <ResumeMatcherGuide />;
  } else if (location.pathname === "/time/superadmin/savedResumes") {
    content = <SavedResumes />;
  } else if (location.pathname === "/time/superadmin/savedJobs") {
    content = <SavedJobsAdmin />;
  } else if (location.pathname === "/time/superadmin/savedJobs") {
    content = <SavedJobsAdmin />;
  } else if (location.pathname === "/time/superadmin/RestrictionLoginStatus") {
    content = <RestrictionAdminLoginStatus />;
  } else if (location.pathname === "/time/superadmin/RestrictionEmployerStatus") {
    content = <RestrictionEmployerLoginStatus />;
  } else if (location.pathname === "/time/superadmin/restrictionConsultant") {
    content = <RestrictionConsultant />;
  } else if (location.pathname === "/time/superadmin/RestrictModuleAccess") {
    content = <RestrictModuleAccess />;
  } else if (location.pathname === "/time/superadmin/AdminLoginStatus") {
    content = <AdminLoginStatus />;
  } else if (location.pathname === "/time/superadmin/EmployerLoginStatus") {
    // content = <EmployerLoginStatus />;
  } else if (location.pathname === "/time/superadmin/ConsultantStatusManagement") {
    content = <ConsultantStatusManagement />;
  } else if (location.pathname === "/time/superadmin/AdminAccessManagement") {
    content = <AdminAccessManagement />;
  }
  else if (location.pathname === "/time/superadmin/AdminProfile") {
    content = <AdminProfile />;
  } else if (location.pathname === "/time/superadmin/GenerateSATReport") {
    
    content = <GenerateSATReport />;
  }
   
  else if (location.pathname === "/time/superadmin/AssignLicensesToConsultant") {
    content = <AssignLicensesToConsultant />;
  }else if (location.pathname === "/time/superadmin/AdminAccessControl") {
    content = <AdminAccessControl />;
  } else if (location.pathname === "/time/superadmin/SATReportGuide") {
    content = <SATReportGuide />;
  } else if (location.pathname === "/time/superadmin/AdminAccessManagement") {
    content = <AdminAccessManagement />;

  } else if (location.pathname === "/time/employee/profileemployee"){
    content = <ProfileEmployee />;
  
  } else if (location.pathname === "/time/employee/timesheetsemployee"){
    content = <TimesheetsEmployee />;
  
  } else if ( location.pathname === "/time/employee/timesubmittedSheets" ) {
    content = <SubmittedSheetsEmployee />;
  
  } else if (location.pathname === "/time/employee/approvedsheetsemployee" ){
    content = < ApprovedSheetsEmployee />;
  }
     else if (location.pathname === "/time/employee/pendingtimesheets" ){
    
    content = <PendingSheetsEmployee />
  }
  else if (location.pathname === "/time/employee/rejectedtimesheetsemployee") {
    content = <RejectedTimeSheetsEmployee />; 
  }

  else if (location.pathname === "/time/superadmin/superadminprofile") {
    content = <SuperAdminProfile />; 
  }

  else if (location.pathname === "/time/superadmin/superadminapprovalmanager") {
    content = <ApprovalManagerSuperAdmin />; 
  }

  else if (location.pathname === "/time/superadmin/superadminemployee") {
    content = <EmployeeSuperAdmin />; 
  } 

  else if (location.pathname === "/time/superadmin/superadminsubmittedsheets"){
    content = <SuperAdminSubmittedSheet />;
}

  else if (location.pathname === "/time/superadmin/superadminapprovedsheets"){
    content = <SuperAdminApprovedSheet />;
}
else if (location .pathname ==="/time/superadmin/superadminpendingsheets"){
  content = <SuperAdminPendingSheet />
}

else if (location.pathname ==="/time/superadmin/superadminrejectedsheets"){
  content = <SuperAdminRejectedSheet />;
} 

else if (location.pathname ==="/time/superadmin/superadminrecalledsheets"){
  content = <SuperAdminRecalledSheet />;
}

else if  (location .pathname ==="/time/superadmin/timesheetsettings"){
  content = <TimeSheetSettings />;
}
else if (location.pathname === "/time/superadmin/organizationsettings"){
  content = <OrganizationSettings />;

} else if (location.pathname === "/time/superadmin/helpdesk"){
content = <SuperAdminHelpDesk />
}

else if (location.pathname === "/time/superadmin/superadminproject"){
  content = <SuperAdminProject />
  }
  else if (location.pathname === "/time/signinguide"){
    content = <SignInGuide />
    }
  
  else {
    content = (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <h2
          style={{
            fontSize: "24px",
            fontWeight: "300",
            color: "#000000",
            marginBottom: "10px",
          }}
        >
          Welcome to Gatnix
        </h2>
        <p
          style={{
            fontSize: "16px",
            lineHeight: "1.6",
            color: "#4F4F4F",
            marginBottom: "20px",
          }}
        >
          Gatnix provides an all-in-one platform to streamline hiring, empower
          talent management, and enhance communication through intelligent
          automation and real-time tracking.
        </p>

        <img
          src="https://res.cloudinary.com/dqdvdseyk/image/upload/v1732015726/rzehjanzhthqr6smjkmx.png"
          alt="Gatnix Overview"
          style={{ width: "60%", height: "auto", marginBottom: "20px" }}
        />

        <h3
          style={{
            fontSize: "20px",
            fontWeight: "300",
            color: "#000000",
            marginTop: "20px",
            marginBottom: "10px",
          }}
        >
          Features
        </h3>
        <p style={{ fontSize: "16px", lineHeight: "1.6", color: "#4F4F4F" }}>
          - Centralized job application tracking with categorization by status,
          company, or position.
          <br />
          - Employee management tools for profile tracking, performance
          monitoring, and task management.
          <br />
          - Automated follow-up services to save time and ensure timely
          communication.
          <br />
          - Real-time updates for clear insights into application progress.
          <br />
          - Email and SMS automation for enhanced communication and efficiency.
          <br />
        </p>

        <h3
          style={{
            fontSize: "20px",
            fontWeight: "300",
            color: "#000000",
            marginTop: "20px",
            marginBottom: "10px",
          }}
        >
          Products
        </h3>
        <p style={{ fontSize: "16px", lineHeight: "1.6", color: "#4F4F4F" }}>
          - <strong>Smart Application Tracker:</strong> Simplify hiring with
          seamless candidate management.
          <br />- <strong>Job Board:</strong> Discover and connect with top
          talent in a dynamic environment.
          <br />- <strong>AI Resume Matcher:</strong> Use AI-powered tools to
          match talent with opportunities.
          <br />- <strong>Timesheet Portal:</strong> Optimize productivity with
          intuitive time-tracking tools.
          <br />
        </p>

        <h3
          style={{
            fontSize: "20px",
            fontWeight: "300",
            color: "#000000",
            marginTop: "20px",
            marginBottom: "10px",
          }}
        >
          Pricing Plans
        </h3>
        <p style={{ fontSize: "16px", lineHeight: "1.6", color: "#4F4F4F" }}>
          Choose from individual or organization plans, starting with free
          trials.
          <br />
          <strong>Individual:</strong> Basic (Free/90 days) and Pro ($7/month).
          <br />
          <strong>Organization:</strong> Basic ($22/month) and Pro ($35/month).
          <br />
        </p>

        <h3
          style={{
            fontSize: "20px",
            fontWeight: "300",
            color: "#000000",
            marginTop: "20px",
            marginBottom: "10px",
          }}
        >
          Customer Support
        </h3>
        <p style={{ fontSize: "16px", lineHeight: "1.6", color: "#4F4F4F" }}>
          - Comprehensive knowledge base for quick answers.
          <br />
          - 24/7 live chat support for personalized assistance.
          <br />- Direct support available at{" "}
          <strong style={{ color: "#000000" }}>+1 (614) 421-7545</strong>.<br />
        </p>
      </div>
    );
  }

  return (
    <>
      <Header />
      <div
        className="account-help-container"
        style={{ display: "flex", height: "100vh" }}
      >
        {/* Sidebar */}
        <div
          className="hamburger"
          onClick={toggleSidebarVisibility}
          style={{
            position: "absolute",
            top: "2rem",
            left: "10px",
            zIndex: 1000,
            cursor: "pointer",
            fontSize: "1.5rem",
          }}
        >
          <FontAwesomeIcon icon={isSidebarVisible ? faTimes : faBars} />
        </div>
        <div
          className="sidebar"
          style={{
            flex: isSidebarVisible ? "0 0 16%" : "0 0 16%",
            padding: isSidebarVisible ? "10px" : "0px",
            backgroundColor: "#f5f5f5",
            transform: isSidebarVisible ? "translateX(0)" : "translateX(-100%)",
            transition: "transform 0.3s ease-in-out",
            height: "100%",
            width: "100%",
            zIndex: 999,
            display: isSidebarVisible ? "flex" : "none",
          }}
        >


          <ul style={{ listStyleType: "none", padding: 0 }}>
          <SearchSidebarTime isSidebarVisible={isSidebarVisible} openMenus={openMenus} handleMenuClick={handleMenuClick} isActive={isActive} />
          <h3  style={{textAlign:'start'}}>Time sheets</h3>
          
          
          <li style={{ padding: "10px", cursor: "pointer" }}>
  <div
    onClick={() => handleMenuClick("superAdmin")}
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    }}
  >
    <span>Super Admin</span>
    <FontAwesomeIcon
      icon={
        openMenus["superAdmin"]
          ? faCircleChevronUp
          : faCircleChevronDown
      }
    />
  </div>
  {openMenus["superAdmin"] && (
    <ul style={{ listStyleType: "none", marginTop: "5px" }}>
  <li>
        <Link
          to="/time/superadmin/superadminprofile"
          className={isActive("/time/superadmin/superadminprofile") ? "active" : ""}
          style={{ textDecoration: "none", color: "inherit" }}
        >
          Is it possible to update profile details ?
        </Link>
      </li>
  <li>
        <Link
          to="/time/superadmin/superadminapprovalmanager"
          className={isActive("/time/superadmin/superadminapprovalmanager") ? "active" : ""}
          style={{ textDecoration: "none", color: "inherit" }}
        >
          How the approval manager is added?
        </Link>
      </li>
  <li>
        <Link
          to="/time/superadmin/superadminemployee"
          className={isActive("/time/superadmin/superadminemployee") ? "active" : ""}
          style={{ textDecoration: "none", color: "inherit" }}
        >
        Details required to add new employee?
        </Link>
      </li>
  <li>
        <Link
          to="/time/superadmin/emaillogs"
          className={isActive("/time/superadmin/emaillogs") ? "active" : ""}
          style={{ textDecoration: "none", color: "inherit" }}
        >
          Does  system allow multiple clients to be added?
        </Link>
      </li>
  <li>
        <Link
          to="/time/superadmin/superadminproject"
          className={isActive("/time/superadmin/superadminproject") ? "active" : ""}
          style={{ textDecoration: "none", color: "inherit" }}
        >
          How the Project is added to employees?
        </Link>
      </li>

      <li>
        <Link
          to="/time/superadmin/superadminsubmittedsheets"
          className={isActive("/time/superadmin/superadminsubmittedsheets") ? "active" : ""}
          style={{ textDecoration: "none", color: "inherit" }}
        >
            Where to view the submitted timesheets ?
        </Link>
      </li>
  <li></li>
  <li>
        <Link
          to="/time/superadmin/superadminapprovedsheets"
          className={isActive("/time/superadmin/superadminapprovedsheets") ? "active" : ""}
          style={{ textDecoration: "none", color: "inherit" }}
        >
             How can I check the timesheet has been approved?
        </Link>
      </li>
  <li>
        <Link
          to="/time/superadmin/superadminpendingsheets"
          className={isActive("/time/superadmin/superadminpendingsheets") ? "active" : ""}
          style={{ textDecoration: "none", color: "inherit" }}
        >
              How can I check the status of my pending timesheet?
        </Link>
      </li>
  <li>
        <Link
          to="/time/superadmin/superadminrejectedsheets"
          className={isActive("/time/superadmin/superadminrejectedsheets") ? "active" : ""}
          style={{ textDecoration: "none", color: "inherit" }}
        >
             How to track the rejected Timesheets?
        </Link>
      </li>
  <li>
        <Link
          to="/time/superadmin/superadminrecalledsheets"
          className={isActive("/time/superadmin/superadminrecalledsheets") ? "active" : ""}
          style={{ textDecoration: "none", color: "inherit" }}
        >
             How to Recall a Timesheet as a Super Admin?
        </Link>
      </li>
  <li>
        <Link
          to="/time/superadmin/timesheetsettings"
          className={isActive("/time/superadmin/timesheetsettings") ? "active" : ""}
          style={{ textDecoration: "none", color: "inherit" }}
        >
          What can be configured in timesheet settings?
        </Link>
      </li>
  <li>
        <Link
          to="/time/superadmin/organizationsettings"
          className={isActive("/time/superadmin/organizationsettings") ? "active" : ""}
          style={{ textDecoration: "none", color: "inherit" }}
        >
          How organization settings affect timesheets?
        </Link>
      </li>

    </ul>
  )}
</li>
     <li>
        <div
          onClick={() => handleMenuClick("approverManagers")}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >


{/* "/time/signinguide" */}
          <span>Approval Managers</span>
          <FontAwesomeIcon
            icon={
              openMenus["approverManagers"]
                ? faCircleChevronUp
                : faCircleChevronDown
            }
          />
        </div>
        {openMenus["approverManagers"] && (
          <ul style={{ listStyleType: "none", marginTop: "5px" }}>
            <li>
              <Link
                to="/time/approverManagers/profile"
                className={isActive("/time/approverManagers/profile") ? "active" : ""}
              >
                Need to Manage Your Profile?
              </Link>
            </li>
            <li>
              <Link
                to="/time/approverManagers/addOrviewemployee"
                className={isActive("/time/approverManagers/addOrviewemployee") ? "active" : ""}
              >
                Want to Add Employee?
              </Link>
            </li>
            <li>
              <Link
                to="/time/approverManagers/addOrViewClient"
                className={isActive("/time/approverManagers/addOrViewClient") ? "active" : ""}
              >
                 You can able to Add  Client?
              </Link>
            </li>
            <li>
              <Link
                to="/time/approverManagers/project"
                className={isActive("/time/approverManagers/project") ? "active" : ""}
              >
                How to Create Project?
              </Link>
            </li>
            <li>
              <Link
                to="/time/approverManagers/timesheet"
                className={isActive("/time/approverManagers/timesheet") ? "active" : ""}
              >
                Why can't I see all timesheets?
              </Link>
            </li>
            <li>
              <Link
                to="/time/approverManagers/timesubmittedSheets"
                className={isActive("/time/approverManagers/timesubmittedSheets") ? "active" : ""}
              >
                Where can I find submitted timesheets?
              </Link>
            </li>
            <li>
              <Link
                to="/time/approverManagers/approvedsheets"
                className={isActive("/time/approverManagers/approvedsheets") ? "active" : ""}
              >
                Can I access my approved timesheets?
              </Link>
            </li>
            <li>
              <Link
                to="/time/approverManagers/pendingtimesheets"
                className={isActive("/time/approverManagers/pendingtimesheets") ? "active" : ""}
              >
                How to track pending timesheets?
              </Link>
            </li>
            <li>
              <Link
                to="/time/approverManagers/rejectedtimesheets"
                className={isActive("/time/approverManagers/rejectedtimesheets") ? "active" : ""}
              >
              How to fix rejected timesheet?
              </Link>
            </li>
            <li>
              <Link
                to="/time/approverManagers/recalledtimesheets"
                className={isActive("/time/approverManagers/recalledtimesheets") ? "active" : ""}
              >
             How to track and manage recalled timesheets?
              </Link>
            </li>
          </ul>
        )}
      </li>

      <li style={{ padding: "10px", cursor: "pointer" }}>
        <div
          onClick={() => handleMenuClick("employee")}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span>Employee</span>
          <FontAwesomeIcon
            icon={
              openMenus["employee"]
                ? faCircleChevronUp
                : faCircleChevronDown
            }
          />
        </div>
        {openMenus["employee"] && (
          <ul style={{ listStyleType: "none", marginTop: "5px" }}>
            <li>
              <Link
                to="/time/employee/profileemployee"
                className={isActive("/time/employee/profileemployee") ? "active" : ""}
              >
                Can I change my profile details?
              </Link>
            </li>
            <li>
              <Link
                to="/time/employee/timesheetsemployee"
                className={isActive("/time/employee/timesheetsemployee") ? "active" : ""}
              >
                Define the process of filling Timesheet?
              </Link>
            </li>
            <li>
              <Link
                to="/time/employee/timesubmittedSheets"
                className={isActive("/time/employee/timesubmittedSheets") ? "active" : ""}
              >
                What happens after I submit a timesheet?
              </Link>
            </li>
            <li>
              <Link
                to="/time/employee/approvedsheetsemployee"
                className={isActive("/time/employee/approvedsheetsemployee") ? "active" : ""}
              >
                Do I get notified when my timesheet is approved?
              </Link>
            </li>
            <li>
              <Link
                to="/time/employee/pendingtimesheets"
                className={isActive("/time/employee/pendingtimesheets") ? "active" : ""}
              >
                Why is my timesheet still pending?
              </Link>
            </li>
            <li>
              <Link
                to="/time/employee/rejectedtimesheetsemployee"
                className={isActive("/time/employee/rejectedtimesheetsemployee") ? "active" : ""}
              >
                What should I do if my timesheet is rejected?
              </Link>
            </li>
            <li>
              <Link
                to="/time/employee/recalledtimesheets"
                className={isActive("/time/employee/recalledtimesheets") ? "active" : ""}
              >
                 How Can I resubmit a recalled timesheet?
              </Link>
            </li>
          </ul>
        )}
      </li>

  
      


  


            {/* Repeat similar structure for Sheet, Submitted Sheets, Approved Sheets, Pending Sheets, Rejected Sheets, and Recalled Sheets */}

            <li style={{ padding: "10px", cursor: "pointer" }}>
              {/* <h3 >Gatnix Help Topics</h3> */}
            </li>

            {/* <li style={{ padding: "10px", cursor: "pointer" }}>
       
              <Link
                to="/time/timesheet/consultant-data"
                style={{ textDecoration: "none", color: "inherit" }}
              >
               Create A Project
              </Link>
            </li> */}
            {/* <li style={{ padding: "10px", cursor: "pointer" }}>
            
              <Link to="/time/timesheet/troubleshooting" style={{ textDecoration: "none", color: "inherit" }}>
              Create Time Sheet
              </Link>
            </li> */}
            {/* <li style={{ padding: "10px", cursor: "pointer" }}>
            
              <Link
                to="/time/timesheet/satreportgeneration"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                SATReportGeneration
              </Link>
            </li> */}

            {/* <li style={{ padding: "10px", cursor: "pointer" }}>
          
              <Link
                to="/time/timesheet/consultantprofileedit"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Consultant Profile Edit
              </Link>
            </li>
            <li style={{ padding: "10px", cursor: "pointer" }}>
           
              <Link
                to="/time/timesheet/schedulerlogs"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Scheduler Logs
              </Link>
            </li>
            <li style={{ padding: "10px", cursor: "pointer" }}>
             
              <Link
                to="/time/timesheet/viewconsultantdetails"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                View Consultant Details
              </Link>
            </li>
            <li style={{ padding: "10px", cursor: "pointer" }}>
              
              <Link
                to="/time/timesheet/emailtemplateguide"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Email Template Guide
              </Link>
            </li>
            <li style={{ padding: "10px", cursor: "pointer" }}>
             
              <Link
                to="/time/timesheet/profilesetup"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Profile Setup
              </Link>
            </li>
            <li style={{ padding: "10px", cursor: "pointer" }}>
              
              <Link
                to="/time/timesheet/vendorclientmanagement"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Vendor Client Management
              </Link>
            </li>
            <li style={{ padding: "10px", cursor: "pointer" }}>
             
              <Link
                to="/time/timesheet/organizationinformation"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Organization Information
              </Link>
            </li>
            <li style={{ padding: "10px", cursor: "pointer" }}>
            
              <Link
                to="/time/timesheet/managesubmissionsheets"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Manage Submission Sheets
              </Link>
            </li>
            <li style={{ padding: "10px", cursor: "pointer" }}>
             
              <Link
                to="/time/timesheet/vieworganizationdetails"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Manage Submission Sheets
              </Link>
            </li>
            <li style={{ padding: "10px", cursor: "pointer" }}>
             
              <Link
                to="/time/timesheet/viewemailhistory"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                View Email History
              </Link>
            </li>
            <li style={{ padding: "10px", cursor: "pointer" }}>
              
              <Link
                to="/time/timesheet/manageschedulersettings"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Manage Scheduler Settings
              </Link>
            </li>
            <li style={{ padding: "10px", cursor: "pointer" }}>
           
              <Link
                to="/time/timesheet/viewschedulerlogs"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                View Scheduler Logs
              </Link>
            </li>
            <li style={{ padding: "10px", cursor: "pointer" }}>
             
              <Link
                to="/time/timesheet/managesatreports"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Manage SAT Reports
              </Link>
            </li>
            <li style={{ padding: "10px", cursor: "pointer" }}>
            
              <Link
                to="/time/timesheet/billingandsatreports"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Billing And SATReports
              </Link>
            </li>
            <li style={{ padding: "10px", cursor: "pointer" }}>
              
              <Link
                to="/time/timesheet/managebillingandreports"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Manage Billing And Reports
              </Link>
            </li>
            <li style={{ padding: "10px", cursor: "pointer" }}>
           
              <Link
                to="/time/timesheet/userandbillingoverview"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                User Billing Overview
              </Link>
            </li>
            <li style={{ padding: "10px", cursor: "pointer" }}>
            
              <Link
                to="/time/timesheet/manageconsultantlicenses"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Manage Consultant Licenses
              </Link>
            </li>

            <li style={{ padding: "10px", cursor: "pointer" }}>
             
              <Link
                to="/time/timesheet/manageconsultantlicenses"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Manage Consultant Licenses
              </Link>
            </li>
            <li style={{ padding: "10px", cursor: "pointer" }}>
            
              <Link
                to="/time/timesheet/manageorders"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Manage Orders
              </Link>
            </li>
            <li style={{ padding: "10px", cursor: "pointer" }}>
             
              <Link
                to="/time/timesheet/resumebuilder"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Resume Builder
              </Link>
            </li>
            <li style={{ padding: "10px", cursor: "pointer" }}>
             
              <Link
                to="/time/timesheet/airesumematcher"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                AIResume Matcher
              </Link>
            </li>
            <li style={{ padding: "10px", cursor: "pointer" }}>
            
              <Link
                to="/time/timesheet/importorcreateresume"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Import CreateResume
              </Link>
            </li>
            <li style={{ padding: "10px", cursor: "pointer" }}>
            
              <Link
                to="/time/timesheet/templatesettings"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Template Settings
              </Link>
            </li>
            <li style={{ padding: "10px", cursor: "pointer" }}>
             
              <Link
                to="/time/timesheet/savedjobs"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Saved Jobs
              </Link>
            </li> */}
          </ul>
        </div>
        <div
          className="hamburger"
          onClick={toggleSidebarVisibility}
          style={{
            position: "absolute",
            top: "10px",
            left: "10px",
            zIndex: 1000,
            cursor: "pointer",
            fontSize: "1.5rem",
          }}
        >
          <FontAwesomeIcon icon={isSidebarVisible ? faTimes : faBars} />
        </div>
        {/* Content Area */}
        <div
          className="content-area"
          style={{
            flex: "1",
            padding: "20px",
            backgroundColor: "white",
            height: "90vh",
            overflowY: "scroll",
          }}
        >
          {content}
        </div>
      </div>
      {/* <Footer1 /> */}
    </>
  );
};

export default Timesheet;
